import {
  Editor,
  Element as SlateElement,
  Node,
  Path,
  Text,
  Transforms
} from 'slate';
import * as serializer from 'basic-editor-value-serializer';

const textElementsV2 = serializer.textElementsV2;

export function getSelectedSingleBlock(editor, selection) {

  if (selection === null || selection === void 0) {
    return null;
  }

  const anchorEntry = Editor.above(editor, {
    at: selection.anchor.path,
    match: matchBlock.bind(null, editor),
    mode: 'lowest'
  });

  const focusEntry = Editor.above(editor, {
    at: selection.focus.path,
    match: matchBlock.bind(null, editor),
    mode: 'lowest'
  });

  if (anchorEntry === void 0 || focusEntry === void 0) {
    return null;
  }

  const anchorPath = anchorEntry[1];
  const focusPath = focusEntry[1];

  if (Path.equals(anchorPath, focusPath) === false) {
    return null;
  }

  const block = anchorEntry[0];

  if (textElementsV2.indexOf(block.type) === -1) {
    return null;
  }

  return {
    block: block,
    path: anchorPath
  };

}

function matchBlock(editor, node) {

  if (SlateElement.isElement(node) === false) {
    return false;
  }

  return Editor.isBlock(editor, node);

}

const SIBLING_CONTEXT_COUNT = 4;

export function buildSelectedBlockContext(editor, blockPath) {

  const context = {};

  if (blockPath.length > 1) {
    const parentPath = Path.parent(blockPath);
    context.parentBlock = {
      path: parentPath,
      block: Node.get(editor, parentPath)
    };
  }

  context.previousSiblingBlocks = collectPreviousSiblingBlocks(editor, blockPath, SIBLING_CONTEXT_COUNT);
  context.nextSiblingBlocks = collectNextSiblingBlocks(editor, blockPath, SIBLING_CONTEXT_COUNT);

  return context;

}

function collectPreviousSiblingBlocks(editor, blockPath, maximumCount) {

  const siblings = [];

  let currentPath = blockPath;

  for (let index = 0; index < maximumCount; index++) {

    if (Path.hasPrevious(currentPath) === false) {
      break;
    }

    const previousPath = Path.previous(currentPath);

    siblings.unshift({
      path: previousPath,
      block: Node.get(editor, previousPath)
    });

    currentPath = previousPath;

  }

  return siblings;

}

function collectNextSiblingBlocks(editor, blockPath, maximumCount) {

  const siblings = [];

  let currentPath = blockPath;

  for (let index = 0; index < maximumCount; index++) {

    const nextPath = Path.next(currentPath);

    if (Node.has(editor, nextPath) === false) {
      break;
    }

    siblings.push({
      path: nextPath,
      block: Node.get(editor, nextPath)
    });

    currentPath = nextPath;

  }

  return siblings;

}

export function buildAIRequestPayload(editor, instruction, selection, singleBlock) {

  return {
    instruction: instruction,
    selection: {
      anchor: selection.anchor,
      focus: selection.focus
    },
    selectedBlock: {
      path: singleBlock.path,
      block: singleBlock.block
    },
    context: buildSelectedBlockContext(editor, singleBlock.path)
  };

}

export function isValidReplaceSelectionResponse(response) {

  if (response === null || typeof response !== 'object') {
    return false;
  }

  if (Array.isArray(response.replacements) === false) {
    return false;
  }

  for (let item of response.replacements) {
    if (Text.isText(item) === false) {
      return false;
    }
  }

  return true;

}

export function applyReplacementToSelection(editor, selection, replacement) {

  Transforms.select(editor, selection);
  Transforms.delete(editor);
  Transforms.insertNodes(editor, replacement);

}